import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

function App(props) {
  const [message, setMessage] = useState("");

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    if (query.get("success")) {
      setMessage("訂單已完成！您將收到確認訊息。");
    }

    if (query.get("canceled")) {
      setMessage(
        "訂單已取消 -- 繼續瀏覽商品，並在準備好時再次結帳。"
      );
    }

    if (query.get("message")) {
        setMessage(
            query.get("message") || "未知錯誤，請稍後再試。"
        );
      }
  }, []);

  return (
    <div className="w-full flex flex-col items-center justify-start p-[16px] bg-[#ddd] flex-1">
        <div className="max-w-[600px] w-[100%] mt-[64px] font-bold text-[24px]">
            {message === 'invalid-product_id' 
              ? '無效的產品 ID，請檢查並重試。'
              : message === 'invalid-product-info'
              ? '產品資訊不完整，請檢查並重試。'
              : message === 'unknown-error'
              ? '未知錯誤，請稍後再試。'
              : message}
        </div>
    </div>
  )
}

export default connect((store) => {
  return {
    token: store.tokenReducer,
    control: store.controlReducer,
  }
})(App)